/** Chave legada (por navegador). Mantida só para migração. */
export const BROWSER_ZOOM_ONBOARDING_KEY = 'klinvia-browser-zoom-onboarding-v1';

/** Sinal de sessão: setado apenas após login/setup, não ao restaurar token salvo. */
export const BROWSER_ZOOM_FRESH_LOGIN_FLAG = 'klinvia-browser-zoom-fresh-login';

const onboardingKeyForUser = (userId: string) => `${BROWSER_ZOOM_ONBOARDING_KEY}:${userId}`;

export function markFreshLoginForZoomOnboarding(): void {
  try {
    sessionStorage.setItem(BROWSER_ZOOM_FRESH_LOGIN_FLAG, '1');
  } catch {
    /* noop */
  }
}

export function clearFreshLoginZoomFlag(): void {
  try {
    sessionStorage.removeItem(BROWSER_ZOOM_FRESH_LOGIN_FLAG);
  } catch {
    /* noop */
  }
}

function isFreshLoginSession(): boolean {
  try {
    return sessionStorage.getItem(BROWSER_ZOOM_FRESH_LOGIN_FLAG) === '1';
  } catch {
    return false;
  }
}

export function hasSeenBrowserZoomOnboarding(userId?: string | null): boolean {
  if (!userId) return true;
  try {
    if (localStorage.getItem(onboardingKeyForUser(userId)) === '1') return true;
    // Migração: quem já viu na versão antiga (chave global por navegador).
    return localStorage.getItem(BROWSER_ZOOM_ONBOARDING_KEY) === '1';
  } catch {
    return true;
  }
}

export function markBrowserZoomOnboardingSeen(userId?: string | null): void {
  if (!userId) return;
  try {
    localStorage.setItem(onboardingKeyForUser(userId), '1');
  } catch {
    /* noop */
  }
}

/**
 * Densidade padrão já vem calibrada no CSS (html zoom 85% em desktop).
 * Mantemos helpers de “visto” para não reabrir em contas antigas se reativarmos a dica.
 */
export function shouldShowBrowserZoomOnboarding(_userId?: string | null): boolean {
  return false;
}

export function isMacPlatform(): boolean {
  if (typeof navigator === 'undefined') return false;
  return /Mac|iPhone|iPad|iPod/i.test(navigator.platform || navigator.userAgent);
}
